import { IdiotSolitaire } from "./Models/Idiot/idiotSolitaire";
import { ScorpionSolitaire } from "./Models/Scorpion/scorpionSolitaire";
import { SolitaireType } from "./Models/solitaireType";

export const activeSolitaires : (SolitaireType)[] = 
    [ ScorpionSolitaire,
        IdiotSolitaire ];